import CoworkingDayPass from './CoworkingDayPass';
import Route from './route';

export default {
  RenderProp: CoworkingDayPass,
  mainRoute: Route,
};
